import React from "react";
import "../styles/Services.css";
function Services() {
  return (
    <div id="services">
      <h1>Our Services</h1>
      <div className="">
        <div className="container">
          <div className="construction">
            <h2>Construction</h2>
            <dl>
              <dt>Earthwork: </dt>
              <dd>Excavation, grading, and site preparation.</dd>

              <dt>Road Construction: </dt>
              <dd>
                Thermoplastic road marking, traffic signage, and road
                infrastructure development.
              </dd>
              <dt>Drainage Systems: </dt>
              <dd>
                RCC drain work, box culverts, slab culverts, and hume pipe
                culverts
              </dd>
              <dt>Structural Work: </dt>
              <dd>
                Construction of buildings, minor bridges, and other concrete
                structures.
              </dd>

              <dt>Project Management: </dt>
              <dd>
                From conceptualization to completion, we provide end-to-end
                project management services to ensure successful project
                delivery.
              </dd>
            </dl>
          </div>
          <div className="it-solutions">
            <h2>IT Solutions: </h2>
            <dl>
              <dt>Software Development:</dt>
              <dd>Building efficient, robust, secure and scalable software.</dd>
              <dt>Web Application: </dt>
              <dd>
                We have expertise in building complex web applications that are
                secure and scalable. (Front-End and Back-End)
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
